import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h4 text-primary" }, "New Goal", -1)
const _hoisted_3 = { class: "row align-items-center justify-content-center" }
const _hoisted_4 = { class: "form-group col-lg-7 col-md-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Name", -1)
const _hoisted_6 = { class: "form-group col-lg-7 col-md-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Description", -1)
const _hoisted_8 = { class: "form-group col-lg-7 col-md-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Set Date", -1)
const _hoisted_10 = { class: "pl-3" }
const _hoisted_11 = { class: "form-group col-lg-7 col-md-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Due Date", -1)
const _hoisted_13 = { class: "pl-3" }
const _hoisted_14 = { class: "row my-3 justify-content-center" }
const _hoisted_15 = { class: "col-xs-12 col-sm-6 col-lg-4 col-xl-3 col-md-5 form-group" }
const _hoisted_16 = { class: "col-xs-12 col-sm-6 col-lg-4 col-xl-3 col-md-5 form-group" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, " Save ", -1)
const _hoisted_19 = { class: "spinner-border spinner-border-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { crumbs: _ctx.crumbs }, null, 8, ["crumbs"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, null, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        button: _withCtx(() => [
          _createElementVNode("span", null, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.back()))
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "mr-1",
                icon: "arrow-left"
              }),
              _createTextVNode(" Go Back ")
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Form, {
        onSubmit: _ctx.save,
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx((meta) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_input_field, { icon: "id-card" }, {
                input: _withCtx(() => [
                  _createVNode(_component_Field, {
                    placeholder: "Enter Name",
                    name: "name",
                    class: _normalizeClass(["form-control shadow-sm", meta.errors.name ? 'is-invalid' : '']),
                    type: "text",
                    modelValue: _ctx.newGoal.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newGoal.name) = $event))
                  }, null, 8, ["class", "modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "name",
                    class: "invalid-feedback"
                  })
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("textarea", {
                name: "description",
                class: _normalizeClass(
              meta.errors.description
                ? 'shadow-sm form-control is-invalid'
                : 'shadow-sm form-control'
            ),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newGoal.description) = $event)),
                rows: "5",
                placeholder: "Enter Description"
              }, null, 2), [
                [_vModelText, _ctx.newGoal.description]
              ]),
              _createVNode(_component_Field, {
                name: "description",
                class: "form-control shadow-sm",
                type: "hidden",
                modelValue: _ctx.newGoal.description,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newGoal.description) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "description",
                class: "invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Datepicker, {
                placeholder: "Please select a date",
                inputClassName: `dp-lg shadow-sm`,
                calendarCellClassName: "dp-round-cell",
                menuClassName: "dp-menu",
                autoApply: "",
                modelValue: _ctx.newGoal.setDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newGoal.setDate) = $event)),
                format: "dd/MM/yyyy",
                uid: "setDate",
                "min-date": new Date(),
                clearable: "",
                enableTimePicker: false
              }, {
                "input-icon": _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "text-primary",
                      icon: "calendar-check"
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "min-date"]),
              _createVNode(_component_Field, {
                name: "setDate",
                class: _normalizeClass(meta.errors.setDate ? 'is-invalid' : ''),
                type: "hidden",
                modelValue: _ctx.newGoal.setDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newGoal.setDate) = $event))
              }, null, 8, ["class", "modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "setDate",
                class: "invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Datepicker, {
                placeholder: "Please select a date",
                inputClassName: `dp-lg shadow-sm is-invalid`,
                calendarCellClassName: "dp-round-cell is-invalid",
                menuClassName: "dp-menu is-invalid",
                autoApply: "",
                modelValue: _ctx.newGoal.dueDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newGoal.dueDate) = $event)),
                format: "dd/MM/yyyy",
                "min-date": new Date(),
                clearable: "",
                uid: "dueDate",
                enableTimePicker: false
              }, {
                "input-icon": _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "text-primary",
                      icon: "calendar-check"
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "min-date"]),
              _createVNode(_component_Field, {
                name: "dueDate",
                class: _normalizeClass(meta.errors.dueDate ? 'is-invalid' : ''),
                type: "hidden",
                modelValue: _ctx.newGoal.dueDate,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newGoal.dueDate) = $event))
              }, null, 8, ["class", "modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dueDate",
                class: "invalid-feedback"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-secondary btn-lg-cus",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (this.$router.back()), ["prevent"]))
              }, " Cancel ")
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "btn-primary btn-lg-cus",
                disabled: _ctx.loading,
                type: "submit"
              }, [
                _hoisted_18,
                _withDirectives(_createElementVNode("span", _hoisted_19, null, 512), [
                  [_vShow, _ctx.loading]
                ])
              ], 8, _hoisted_17)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createVNode(_component_ConfirmationModal, { ref: "confirmDialogue" }, null, 512)
  ], 64))
}